<template>
  <n-input v-model="moneyValue" type="number" step="0.01" v-bind="$attrs">
    <span v-if="currencySymbol" slot="prepend" class="grey lighten-2 px-4">{{currencySymbol}}</span>
    <slot name="label" slot="label" slot-scope="{label}" :label="label"></slot> <!-- forward label slot content to <n-input>'s label slot -->
    <slot name="prepend" slot="prepend"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
    <slot name="append" slot="append"></slot> <!-- forward prepend slot content to <n-input>'s prepend slot -->
    <slot name="help" slot="help"></slot> <!-- forward help slot content to <n-input>'s help slot -->
    <slot name="default" slot="default"></slot> <!-- forward default slot content to <n-input>'s default slot -->
  </n-input>
</template>

<script>
  export default {

    props: {
      value: { required: true },
      currencySymbol: { type: String },
    },

    computed: {
      // Converts from cents to rands
      moneyValue: {
        get() {
          return this.value != null
            ? this.value / 100
            : null
        },
        set(val) {
          this.$emit('input', val * 100)
        }
      },
    },
  }
</script>